import store from '../store'
export function isLogin() {
    if(!window.localStorage.getItem('utoken')){
        store.commit('setDialogLogin',true);
        return false
    }else{
        return true
    }
}



// WEBPACK FOOTER //
// ./src/api/isLogin.js